import round from "./round";

/**
 *
 * @param {Number} input
 * @param {Number} last
 * @param {Boolean} enter
 */
const precisePercents = (input, last, enter) => {
  if (input === 0.9999 && last > 0) {
    return 1;
  }
  if (input >= 1 && last < 1) {
    return 1;
  }
  if (input > 0 && input < 0.005) {
    return 0;
  }
  if (input > 1 && input < 1.005) {
    return 1;
  }
  if (enter && input > 0 && last < 0) {
    return 0;
  }
  if (!enter && input > 0 && last > 1) {
    return 0;
  }
  if (!enter && input === 0 && last < 0) {
    return 1;
  }

  return input;
};

export default precisePercents;
